import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  getString(key: string): string {
    return localStorage.getItem(key) ?? '';
  }

  setString(key: string, value) {
    localStorage.setItem(key, value);
  }
}
